import { render, staticRenderFns } from "./myPromiseGoodsSearch.vue?vue&type=template&id=72d0133e"
import script from "./myPromiseGoodsSearch.vue?vue&type=script&lang=js"
export * from "./myPromiseGoodsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports